import React, { Component } from "react";
import TitlePage from "../components/TitlePage";
import MenuNavbar from "../components/MenuNavbar";
import _ from "underscore";

import "./Integrations.css";

const images = {
  "Abacus": "Abacus.png",
  "Accelo": "Accelo.png",
  "AccountingSuite": "AccountingSuite.png",
  "Accredible Certificates": "AccredibleCertificates.png",
  "Acquire": "Acquire.png",
  "Act! 365": "Act365.png",
  "Action Network": "ActionNetwork.png",
  "ActionSprout": "ActionSprout.png",
  "ActiveCampaign": "ActiveCampaign.png",
  "Active Collab": "ActiveCollab.png",
  "ActiveDEMAND": "ActiveDEMAND.png",
  "ActiveTrail": "ActiveTrail.png",
  "Act-On": "ActOn.png",
  "Act! Premium": "ActPremium.png",
  "Acuity Scheduling": "AcuityScheduling.png",
  "AdaptiveU": "AdaptiveU.png",
  "AddressFinder Australia": "AddressFinderAustralia.png",
  "AdRoll": "AdRoll.png",
  "AdviserLogic": "AdviserLogic.png",
  "AerisWeather": "AerisWeather.png",
  "AeroLeads": "AeroLeads.png",
  "Aero Workflow": "AeroWorkflow.png",
  "Affinity": "Affinity.png",
  "Agendize": "Agendize.png",
  "Agendor": "Agendor.png",
  "Agent 3000": "Agent3000.png",
  "Agent Legend": "AgentLegend.png",
  "Agile CRM": "AgileCRM.png",
  "Aha!": "Aha.png",
  "Aimtell": "Aimtell.png",
  "Airtable": "Airtable.png",
  "Airteach": "Airteach.png",
  "Aiva": "Aiva.png",
  "Akna": "Akna.png",
  "Albacross": "Albacross.png",
  "Alegra": "Alegra.png",
  "allmysms": "allmysms.png",
  "Allthings": "Allthings.png",
  "Alore CRM": "AloreCRM.png",
  "Alterdesk": "Alterdesk.png",
  "Amazon CloudFront": "AmazonCloudFront.png",
  "Amazon CloudWatch": "AmazonCloudWatch.png",
  "Amazon EC2": "AmazonEC2.png",
  "Amazon Polly": "AmazonPolly.png",
  "Amazon Seller Central": "AmazonSellerCentral.png",
  "amoCRM": "amoCRM.png",
  "Ampliz": "Ampliz.png",
  "Analytic Call Tracking": "AnalyticCallTracking.png",
  "AND CO": "ANDCO.png",
  "Intermedia AnyMeeting": "IntermediaAnyMeeting.png",
  "AnywhereWorks": "AnywhereWorks.png",
  "APE Mobile": "APEMobile.png",
  "Apify": "Apify.png",
  "Samanage": "Samanage.png",
  "Cheddar": "Cheddar.png",
  "Setmore Appointments": "SetmoreAppointments.png",
  "10to8 Online Booking": "10to8OnlineBooking.png",
  "Qortex": "Qortex.png",
  "Pingdom": "Pingdom.png",
  "Product Hunt": "ProductHunt.png",
  "Swarm": "Swarm.png",
  "Geckoboard": "Geckoboard.png",
  "BugHerd": "BugHerd.png",
  "Raven Tools": "RavenTools.png",
  "iFormBuilder": "iFormBuilder.png",
  "Rezdy": "Rezdy.png",
  "Datadog": "Datadog.png",
  "Mobyt SMS": "MobytSMS.png",
  "Exceptionless": "Exceptionless.png",
  "Sendicate": "Sendicate.png",
  "Jenkins": "Jenkins.png",
  "Displet": "Displet.png",
  "App.net": "Appnet.png",
  "eStreamDesk": "eStreamDesk.png",
  "Osmosis": "Osmosis.png",
  "KickoffLabs": "KickoffLabs.png",
  "FollowUp.cc": "FollowUpcc.png",
  "Planview Leankit": "PlanviewLeankit.png",
  "FluidSurveys": "FluidSurveys.png",
  "Paymill": "Paymill.png",
  "Scout Monitoring": "ScoutMonitoring.png",
  "StockTwits": "StockTwits.png",
  "Airbrake": "Airbrake.png",
  "Nozbe": "Nozbe.png",
  "TelAPI": "TelAPI.png",
  "Azure Web Apps": "AzureWebApps.png",
  "Calldrip": "Calldrip.png",
  "Lander": "Lander.png",
  "Pushwoosh": "Pushwoosh.png",
  "Kanban Tool": "KanbanTool.png",
  "Trigger": "Trigger.png",
  "Mention": "Mention.png",
  "Hoiio": "Hoiio.png",
  "FreeAgent": "FreeAgent.png",
  "Cerb": "Cerb.png",
  "FormForAll": "FormForAll.png",
  "RequirementOne": "RequirementOne.png",
  "Campayn": "Campayn.png",
  "Papyrs": "Papyrs.png",
  "INinbox": "INinbox.png",
  "SoundCloud": "SoundCloud.png",
  "Quote Roller": "QuoteRoller.png",
  "Toodledo": "Toodledo.png",
  "Diffbot": "Diffbot.png",
  "Formidable Forms": "FormidableForms.png",
  "Pushbullet": "Pushbullet.png",
  "WP Remote": "WPRemote.png",
  "Crittercism": "Crittercism.png",
  "ORBTR": "ORBTR.png",
  "Kanbanery": "Kanbanery.png",
  "Pinboard": "Pinboard.png",
  "Chatter": "Chatter.png",
  "Tender Support": "TenderSupport.png",
  "SendHub": "SendHub.png",
  "Tatango": "Tatango.png",
  "Leftronic": "Leftronic.png",
  "Ambassador": "Ambassador.png",
  "MailUp": "MailUp.png",
  "Apparound": "Apparound.png",
  "Appbot": "Appbot.png",
  "Appointlet": "Appointlet.png",
  "Appointy": "Appointy.png",
  "Approval Donkey": "ApprovalDonkey.png",
  "AppsForOps Timeline": "AppsForOpsTimeline.png",
  "App Status by Zapier": "AppStatusbyZapier.png",
  "Arthur": "Arthur.png",
  "ArtiBot.ai": "ArtiBotai.png",
  "Artichoke": "Artichoke.png",
  "Asana": "Asana.png",
  "AskNicely": "AskNicely.png",
  "Assembla": "Assembla.png",
  "Assessment Generator": "AssessmentGenerator.png",
  "Attach": "Attach.png",
  "Autoklose": "Autoklose.png",
  "Automational": "Automational.png",
  "Autopilot": "Autopilot.png",
  "AutoRemote": "AutoRemote.png",
  "Autotask": "Autotask.jpeg",
  "AutoXLM": "AutoXLM.png",
  "Avaza": "Avaza.png",
  "Avochato": "Avochato.png",
  "AWeber": "AWeber.png",
  "AWS Lambda": "AWSLambda.png",
  "Axosoft": "Axosoft.png",
  "Azendoo": "Azendoo.png",
  "BambooHR": "BambooHR.png",
  "Bambu by Sprout Social": "BambubySproutSocial.png",
  "Bappo": "Bappo.png",
  "BarCloud": "BarCloud.png",
  "Baremetrics": "Baremetrics.png",
  "Basecamp 3": "Basecamp3.png",
  "Basecamp Classic": "BasecampClassic.png",
  "Basecamp 2": "Basecamp2.png",
  "Basin": "Basin.png",
  "Batchbook": "Batchbook.png",
  "Beamer": "Beamer.png",
  "Beanstalk": "Beanstalk.png",
  "Beeminder": "Beeminder.png",
  "Beepsend SMS": "BeepsendSMS.png",
  "Benchmark Email": "BenchmarkEmail.png",
  "Betasend": "Betasend.png",
  "Better Proposals": "BetterProposals.png",
  "Better Voice": "BetterVoice.png",
  "bexio": "bexio.png",
  "Bidsketch": "Bidsketch.png",
  "Big Cartel": "BigCartel.png",
  "BigCommerce": "BigCommerce.png",
  "BigML": "BigML.png",
  "Bind ERP": "BindERP.png",
  "BirdEye": "BirdEye.png",
  "Bitbucket": "Bitbucket.png",
  "Bitly": "Bitly.png",
  "Biztera": "Biztera.png",
  "Bizzabo": "Bizzabo.png",
  "Bizzow": "Bizzow.png",
  "Bkper": "Bkper.png",
  "BL.INK": "BLINK.png",
  "Blink": "Blink.png",
  "Bmby": "Bmby.png",
  "Boingnet": "Boingnet.png",
  "Boleto Simples": "BoletoSimples.png",
  "BombBomb.com": "BombBombcom.png",
  "Bonjoro": "Bonjoro.png",
  "Bonsai": "Bonsai.png",
  "Bonusly": "Bonusly.png",
  "Bookafy": "Bookafy.png",
  "BookingSync": "BookingSync.png",
  "Book Like A Boss": "BookLikeABoss.png",
  "BoomTown!": "BoomTown.png",
  "Boon": "Boon.png",
  "BotatBot": "BotatBot.png",
  "Botsify": "Botsify.png",
  "BowTie.io": "BowTieio.png",
  "Box": "Box.png",
  "Braintree": "Braintree.jpeg",
  "Brand Gaming": "BrandGaming.png",
  "Cocapina": "Cocapina.png",
  "BrandMentions": "BrandMentions.png",
  "Brandquiz": "Brandquiz.png",
  "Breezy HR": "BreezyHR.png",
  "Brick FTP": "BrickFTP.png",
  "BrightMove": "BrightMove.png",
  "Brivity": "Brivity.png",
  "bttn": "bttn.png",
  "Bucket.io": "Bucketio.png",
  "Buffer": "Buffer.png",
  "Builderall Mailingboss": "BuilderallMailingboss.png",
  "BulkGate": "BulkGate.png",
  "BulkSMS.my": "BulkSMSmy.png",
  "Bullhorn CRM": "BullhornCRM.png",
  "Burner": "Burner.png",
  "Burst SMS": "BurstSMS.png",
  "Butleroy": "Butleroy.png",
  "BuySellAds": "BuySellAds.png",
  "TapRight": "TapRight.png",
  "Calendly": "Calendly.png",
  "Callexa Feedback": "CallexaFeedback.png",
  "CallFire": "CallFire.png",
  "CallHub": "CallHub.png",
  "Callingly": "Callingly.png",
  "Call Loop": "CallLoop.png",
  "CallOnTheGo": "CallOnTheGo.png",
  "CallRail": "CallRail.png",
  "CallTrackingMetrics": "CallTrackingMetrics.png",
  "Campaign1to1": "Campaign1to1.png",
  "Campaign Monitor": "CampaignMonitor.png",
  "Campfire": "Campfire.png",
  "CandidateZip": "CandidateZip.png",
  "Canny": "Canny.png",
  "GoCanvas": "GoCanvas.png",
  "Capsule CRM": "CapsuleCRM.png",
  "Carma Marketing Hub": "CarmaMarketingHub.png",
  "Cascade Strategy": "CascadeStrategy.png",
  "Caspio Cloud Database": "CaspioCloudDatabase.png",
  "CastingWords": "CastingWords.png",
  "Cayzu": "Cayzu.png",
  "Celoxis": "Celoxis.png",
  "Cflow": "Cflow.png",
  "Chargebee": "Chargebee.png",
  "ChargeOver": "ChargeOver.png",
  "Chargify": "Chargify.png",
  "CharityGiving": "CharityGiving.png",
  "ChartMogul": "ChartMogul.png",
  "ChatBot": "ChatBot.png",
  "Chatforma": "Chatforma.png",
  "Chatfuel for Facebook": "ChatfuelforFacebook.png",
  "Chatra": "Chatra.png",
  "ChatWork": "ChatWork.png",
  "CheckMarket": "CheckMarket.png",
  "Checkvist": "Checkvist.png",
  "Cincopa": "Cincopa.png",
  "Circuit": "Circuit.png",
  "Cisco Webex Teams": "CiscoWebexTeams.png",
  "CivicEngage": "CivicEngage.png",
  "Clearbit": "Clearbit.png",
  "CleverReach": "CleverReach.png",
  "Clevertim CRM": "ClevertimCRM.png",
  "ClicData": "ClicData.png",
  "Click2Mail": "Click2Mail.png",
  "Clickatell": "Clickatell.png",
  "ClickDesk": "ClickDesk.png",
  "ClickFunnels": "ClickFunnels.png",
  "ClickSend SMS": "ClickSendSMS.png",
  "ClickTime": "ClickTime.png",
  "ClickUp": "ClickUp.png",
  "Cliengo": "Cliengo.png",
  "Client Dispute Manager": "ClientDisputeManager.png",
  "ClientSuccess": "ClientSuccess.png",
  "ClinchPad": "ClinchPad.png",
  "Clio": "Clio.png",
  "ClockShark": "ClockShark.png",
  "Clockwork SMS": "ClockworkSMS.png",
  "Close": "Close.png",
  "Cloud Attract": "CloudAttract.png",
  "Cloudbeds": "Cloudbeds.png",
  "CloudBoost": "CloudBoost.png",
  "CloudCart": "CloudCart.png",
  "CloudConvert": "CloudConvert.png",
  "Cloudinary": "Cloudinary.png",
  "Cloze": "Cloze.png",
  "Clubworx": "Clubworx.png",
  "CM.com": "CMcom.png",
  "CMNTY": "CMNTY.png",
  "Podia": "Podia.png",
  "Cobot": "Cobot.png",
  "Coda": "Coda.png",
  "CodeREADr": "CodeREADr.png",
  "Cognito Forms": "CognitoForms.png",
  "Cogsworth": "Cogsworth.png",
  "CommCare": "CommCare.png",
  "CompanyCam": "CompanyCam.png",
  "CompanyHub": "CompanyHub.png",
  "Confluence": "Confluence.png",
  "ConnectWise Manage": "ConnectWiseManage.png",
  "Constant Contact": "ConstantContact.png",
  "123FormBuilder": "123FormBuilder.png",
  "Contactually": "Contactually.png",
  "ContactUs.com": "ContactUscom.png",
  "Contap": "Contap.png",
  "Contentful": "Contentful.png",
  "Contentools": "Contentools.png",
  "Contractbook": "Contractbook.png",
  "Convenia": "Convenia.png",
  "ConvergeHub": "ConvergeHub.png",
  "ConvertAPI": "ConvertAPI.png",
  "ConvertKit": "ConvertKit.png",
  "Convo": "Convo.png",
  "Copper": "Copper.png",
  "Corsizio": "Corsizio.png",
  "CoSchedule": "CoSchedule.png",
  "Coupon Carrier": "CouponCarrier.png",
  "Coveo": "Coveo.png",
  "CozyCal": "CozyCal.png",
  "Craft": "Craft.png",
  "CrazyCall": "CrazyCall.png",
  "Createsend": "Createsend.png",
  "Credit Repair Cloud": "CreditRepairCloud.png",
  "Crexendo": "Crexendo.png",
  "Crisp": "Crisp.png",
  "CRM Connector": "CRMConnector.png",
  "Cronofy Calendar Connector": "CronofyCalendarConnector.png",
  "Crowdcast": "Crowdcast.png",
  "Crugo": "Crugo.png",
  "SignNow": "SignNow.png",
  "Cumulocity": "Cumulocity.png",
  "Curated": "Curated.png",
  "Customer.guru": "Customerguru.png",
  "Customer.io": "Customerio.png",
  "CustomerLabs": "CustomerLabs.png",
  "Custom Gateway OMS": "CustomGatewayOMS.png",
  "Cyberimpact": "Cyberimpact.png",
  "Cyfe": "Cyfe.png",
  "Dagger For Ethereum": "DaggerForEthereum.png",
  "monday.com": "mondaycom.png",
  "Dasheroo": "Dasheroo.png",
  "Das Keyboard 5Q": "DasKeyboard5Q.png",
  "Databox": "Databox.png",
  "Datadeck": "Datadeck.png",
  "DataScope Forms": "DataScopeForms.png",
  "DataValidation": "DataValidation.png",
  "Daylite": "Daylite.png",
  "Deadline Funnel": "DeadlineFunnel.png",
  "DealMachine": "DealMachine.png",
  "DEAR Inventory": "DEARInventory.png",
  "DeepCrawl": "DeepCrawl.png",
  "Delighted": "Delighted.png",
  "Delivra": "Delivra.png",
  "Demio": "Demio.png",
  "Deputy": "Deputy.png",
  "Descript": "Descript.png",
  "Design Pickle": "DesignPickle.png",
  "DeskMoz": "DeskMoz.png",
  "Deskpro": "Deskpro.png",
  "DeskTime": "DeskTime.png",
  "Desk": "Desk.png",
  "Detectify": "Detectify.png",
  "Device Magic": "DeviceMagic.png",
  "DialMyCalls": "DialMyCalls.png",
  "Digistore24": "Digistore24.png",
  "DigitalOcean": "DigitalOcean.png",
  "Direct Mail": "DirectMail.png",
  "Discord": "Discord.png",
  "Dispatch": "Dispatch.png",
  "Disqus": "Disqus.png",
  "Docparser": "Docparser.png",
  "DocSend": "DocSend.png",
  "Docsify": "Docsify.png",
  "Docupilot": "Docupilot.png",
  "Donately": "Donately.png",
  "Donation Manager RedCloud": "DonationManagerRedCloud.png",
  "Donorbox": "Donorbox.png",
  "Doppler": "Doppler.png",
  "Dotcom Monitor": "DotcomMonitor.jpg",
  "dotdigital": "dotdigital.png",
  "Dovetail": "Dovetail.png",
  "DPD": "DPD.png",
  "Dribbble": "Dribbble.png",
  "Drift": "Drift.png",
  "Drip": "Drip.png",
  "Dropbox": "Dropbox.png",
  "Dropified": "Dropified.png",
  "Dubsado": "Dubsado.png",
  "Microsoft Dynamics CRM (For use with Dynamics version 8)": "MicrosoftDynamicsCRMForusewithDynamicsversion8.png",
  "Amazon DynamoDB": "AmazonDynamoDB.png",
  "EASI'R": "EASIR.png",
  "EasyMe": "EasyMe.png",
  "Easy Project": "EasyProject.png",
  "Easy Projects": "EasyProjects.png",
  "Easypromos": "Easypromos.png",
  "EasyWebinar": "EasyWebinar.png",
  "Coassemble": "Coassemble.png",
  "Ecwid": "Ecwid.png",
  "MeetEdgar": "MeetEdgar.png",
  "eEndorsements": "eEndorsements.png",
  "eFront Pro": "eFrontPro.png",
  "Egnyte": "Egnyte.png",
  "E-goi": "Egoi.png",
  "Elastic Email": "ElasticEmail.png",
  "Elmah.io": "Elmahio.png",
  "elopage": "elopage.png",
  "Elore": "Elore.png",
  "Hunter": "Hunter.png",
  "EmailOctopus": "EmailOctopus.png",
  "Emma": "Emma.png",
  "Emojics": "Emojics.png",
  "Enalyzer": "Enalyzer.png",
  "EngageBay Marketing": "EngageBayMarketing.png",
  "Engage Talent": "EngageTalent.png",
  "Envoy": "Envoy.png",
  "Epos Now": "EposNow.png",
  "EquiiTEXT": "EquiiTEXT.png",
  "Esendex": "Esendex.png",
  "Esponce": "Esponce.png",
  "eSputnik": "eSputnik.png",
  "essensys Operate": "essensysOperate.png",
  "eTermin": "eTermin.png",
  "Evenium": "Evenium.png",
  "Eventable": "Eventable.png",
  "Teem": "Teem.png",
  "Eventbrite": "Eventbrite.png",
  "Event Farm": "EventFarm.png",
  "Eventmaker": "Eventmaker.png",
  "EventTemple": "EventTemple.png",
  "Eventzilla": "Eventzilla.png",
  "Everbridge Suite": "EverbridgeSuite.png",
  "Evernote": "Evernote.png",
  "Evernote Business": "EvernoteBusiness.png",
  "Excel": "Excel.png",
  "Exercise.com": "Exercisecom.png",
  "Expensify": "Expensify.png",
  "Explara": "Explara.png",
  "ExpressPigeon": "ExpressPigeon.png",
  "ezidox": "ezidox.png",
  "Facebook Custom Audiences": "FacebookCustomAudiences.png",
  "Facebook Groups": "FacebookGroups.png",
  "Facebook Lead Ads": "FacebookLeadAds.png",
  "Facebook Offline Conversions": "FacebookOfflineConversions.png",
  "Facebook Pages": "FacebookPages.png",
  "FacturaDirecta": "FacturaDirecta.png",
  "FastField Mobile Forms": "FastFieldMobileForms.png",
  "Fattura24": "Fattura24.png",
  "Favro": "Favro.png",
  "FeedBlitz": "FeedBlitz.png",
  "Feedier": "Feedier.png",
  "Feedly": "Feedly.png",
  "Feefo": "Feefo.png",
  "Fidelizador": "Fidelizador.png",
  "FieldGoal": "FieldGoal.png",
  "FileCloud": "FileCloud.png",
  "FileInvite": "FileInvite.png",
  "FileStack": "FileStack.png",
  "FireText": "FireText.png",
  "Fleep": "Fleep.png",
  "Flexie CRM": "FlexieCRM.png",
  "Flic": "Flic.png",
  "Flickr": "Flickr.png",
  "Float": "Float.png",
  "Flock": "Flock.png",
  "Flowdock": "Flowdock.png",
  "Flowster": "Flowster.png",
  "Focuster": "Focuster.jpg",
  "FogBugz": "FogBugz.png",
  "Follow Up Boss": "FollowUpBoss.png",
  "Fomo": "Fomo.png",
  "ForceManager": "ForceManager.png",
  "Formcarry": "Formcarry.png",
  "Formdesk": "Formdesk.png",
  "Formitize": "Formitize.jpg",
  "FormKeep": "FormKeep.png",
  "Formlets": "Formlets.png",
  "Formsite": "Formsite.png",
  "Forms On Fire": "FormsOnFire.png",
  "Formsquash": "Formsquash.png",
  "Formstack": "Formstack.png",
  "FormTitan": "FormTitan.png",
  "Forte Payments": "FortePayments.png",
  "4Dem.it": "4Demit.png",
  "4screens": "4screens.png",
  "FraudLabs Pro": "FraudLabsPro.png",
  "Freckle": "Freckle.png",
  "Freedcamp": "Freedcamp.png",
  "Freee": "Freee.png",
  "FreshBooks Classic": "FreshBooksClassic.png",
  "FreshBooks New": "FreshBooksNew.png",
  "Freshdesk": "Freshdesk.png",
  "FreshMail": "FreshMail.png",
  "Freshsales": "Freshsales.png",
  "Freshservice": "Freshservice.png",
  "Front": "Front.png",
  "Fulcrum": "Fulcrum.png",
  "FullContact": "FullContact.png",
  "Fyipe": "Fyipe.png",
  "Fyrebox": "Fyrebox.png",
  "G2 Crowd": "G2Crowd.png",
  "GenieBelt": "GenieBelt.png",
  "Genoo": "Genoo.png",
  "GatherUp": "GatherUp.png",
  "GetProspect": "GetProspect.png",
  "GetResponse": "GetResponse.png",
  "GetSiteControl": "GetSiteControl.png",
  "GetSwift": "GetSwift.png",
  "Ghost": "Ghost.png",
  "Gift Up!": "GiftUp.png",
  "GigaBook": "GigaBook.png",
  "Giphy": "Giphy.png",
  "Gist": "Gist.png",
  "GitHub": "GitHub.png",
  "GitLab": "GitLab.png",
  "GivingFuel": "GivingFuel.png",
  "Glip": "Glip.png",
  "GO1": "GO1.png",
  "GoFormz": "GoFormz.png",
  "Goodbits": "Goodbits.png",
  "Google Analytics": "GoogleAnalytics.png",
  "Google Calendar": "GoogleCalendar.png",
  "Google Cloud Print": "GoogleCloudPrint.png",
  "Google Contacts": "GoogleContacts.png",
  "Google Docs": "GoogleDocs.png",
  "Google Drive": "GoogleDrive.png",
  "Firebase / Firestore": "FirebaseFirestore.png",
  "Google Forms": "GoogleForms.png",
  "Google Glass": "GoogleGlass.png",
  "Gmail": "Gmail.png",
  "Google Sheets": "GoogleSheets.png",
  "Google Slides": "GoogleSlides.png",
  "Google Tasks": "GoogleTasks.png",
  "Google URL Shortener": "GoogleURLShortener.png",
  "GoSquared": "GoSquared.png",
  "GoToMeeting": "GoToMeeting.png",
  "GoToTraining": "GoToTraining.png",
  "GoToWebinar": "GoToWebinar.png",
  "Gravity Forms": "GravityForms.png",
  "Greenhouse": "Greenhouse.png",
  "GreenRope": "GreenRope.png",
  "Greetly": "Greetly.png",
  "Gripp": "Gripp.png",
  "Gro CRM": "GroCRM.png",
  "Groove": "Groove.png",
  "Grow": "Grow.png",
  "Growlabs": "Growlabs.png",
  "NorthStar by GrowthHackers": "NorthStarbyGrowthHackers.png",
  "GTX SMS": "GTXSMS.png",
  "Gumroad": "Gumroad.png",
  "Gust": "Gust.png",
  "Handshake": "Handshake.png",
  "Handwrytten": "Handwrytten.png",
  "HappyFox Chat": "HappyFoxChat.png",
  "HappyFox": "HappyFox.png",
  "Harvest": "Harvest.png",
  "Harvestr": "Harvestr.png",
  "Hatchbuck": "Hatchbuck.png",
  "HelloAlex": "HelloAlex.png",
  "Hello Bar": "HelloBar.png",
  "HelloSign": "HelloSign.png",
  "Help Scout": "HelpScout.png",
  "Heymarket SMS": "HeymarketSMS.png",
  "Highline": "Highline.png",
  "Highrise": "Highrise.png",
  "HipChat": "HipChat.png",
  "Hiveage": "Hiveage.png",
  "Hiver": "Hiver.png",
  "Hive": "Hive.png",
  "HoneyBook": "HoneyBook.png",
  "HootBoard": "HootBoard.png",
  "Hootsuite": "Hootsuite.png",
  "Horntell": "Horntell.png",
  "Horoshop": "Horoshop.png",
  "HotProfile": "HotProfile.png",
  "HotspotSystem": "HotspotSystem.png",
  "HourStack": "HourStack.png",
  "Hub Planner": "HubPlanner.png",
  "HubSpot": "HubSpot.png",
  "HubSpot CRM": "HubSpotCRM.png",
  "Humanitix": "Humanitix.png",
  "iContact": "iContact.png",
  "iContact Pro": "iContactPro.png",
  "I Done This": "IDoneThis.png",
  "IDX Leads": "IDXLeads.png",
  "iHomefinder": "iHomefinder.png",
  "Image Relay": "ImageRelay.png",
  "Inbound Now": "InboundNow.png",
  "indemandly": "indemandly.png",
  "Index": "Index.png",
  "Infobip": "Infobip.png",
  "InforUMobile": "InforUMobile.png",
  "Infusionsoft": "Infusionsoft.png",
  "inkXE": "inkXE.png",
  "Inside Sales Box": "InsideSalesBox.png",
  "Insightly": "Insightly.png",
  "Freshping": "Freshping.png",
  "Instabot: Chatbot Platform": "InstabotChatbotPlatform.png",
  "Instagram Custom Audiences": "InstagramCustomAudiences.png",
  "Instagram": "Instagram.png",
  "Instagram Lead Ads": "InstagramLeadAds.png",
  "Instant Contact": "InstantContact.png",
  "Instapage": "Instapage.png",
  "Instapaper": "Instapaper.png",
  "Intelichat": "Intelichat.png",
  "Intellinote": "Intellinote.png",
  "Interact": "Interact.png",
  "Interakt": "Interakt.png",
  "Intercom": "Intercom.png",
  "Interseller": "Interseller.png",
  "Intuiface": "Intuiface.png",
  "Invoco": "Invoco.png",
  "InvoiceBerry": "InvoiceBerry.png",
  "Invoiced": "Invoiced.png",
  "Invoice Ninja": "InvoiceNinja.png",
  "inwise": "inwise.png",
  "IP2Location": "IP2Location.png",
  "iRefer": "iRefer.png",
  "iSendPro SMS": "iSendProSMS.jpg",
  "Iterate": "Iterate.png",
  "ITM Platform": "ITMPlatform.png",
  "Ivanti Service Manager": "IvantiServiceManager.png",
  "iZooto": "iZooto.png",
  "Wisembly Jam": "WisemblyJam.png",
  "Jasmin": "Jasmin.png",
  "Jira": "Jira.png",
  "Jitbit Helpdesk": "JitbitHelpdesk.png",
  "JobNimbus": "JobNimbus.png",
  "join.me": "joinme.png",
  "Joomag": "Joomag.png",
  "JotForm": "JotForm.png",
  "Jumplead": "Jumplead.png",
  "JVZoo": "JVZoo.png",
  "Kajabi": "Kajabi.png",
  "KanbanFlow": "KanbanFlow.png",
  "Kanbanize": "Kanbanize.png",
  "karmaCRM": "karmaCRM.png",
  "Kayako": "Kayako.png",
  "Keep In Touch": "KeepInTouch.png",
  "Kickbox": "Kickbox.png",
  "Kintone": "Kintone.png",
  "KIRIM.EMAIL": "KIRIMEMAIL.png",
  "KiSSFLOW": "KiSSFLOW.png",
  "Kissmetrics": "Kissmetrics.png",
  "Klaviyo": "Klaviyo.png",
  "Klenty": "Klenty.png",
  "Klick-Tipp": "KlickTipp.png",
  "Klipfolio": "Klipfolio.png",
  "Knack": "Knack.png",
  "KonnektiveCRM": "KonnektiveCRM.png",
  "Kunversion+": "Kunversion.png",
  "Kyvio": "Kyvio.png",
  "LAHAR": "LAHAR.png",
  "Landbot": "Landbot.png",
  "Launch27": "Launch27.png",
  "Lawcus": "Lawcus.png",
  "LeadAbode": "LeadAbode.png",
  "Leadberry": "Leadberry.png",
  "LeadBoxer": "LeadBoxer.png",
  "Lead Closer": "LeadCloser.png",
  "Lead Connect": "LeadConnect.png",
  "LeadExpress": "LeadExpress.png",
  "Leadfeeder": "Leadfeeder.png",
  "LeadFlip": "LeadFlip.png",
  "Leadformly": "Leadformly.png",
  "LeadOutcome": "LeadOutcome.png",
  "Leadpages": "Leadpages.png",
  "leadPops": "leadPops.png",
  "LeadQuizzes 3": "LeadQuizzes3.png",
  "LeadQuizzes": "LeadQuizzes.png",
  "LeadSimple": "LeadSimple.png",
  "LeadSquared": "LeadSquared.png",
  "LeagueApps": "LeagueApps.png",
  "Learner Community": "LearnerCommunity.png",
  "LearnWorlds": "LearnWorlds.png",
  "lemlist": "lemlist.png",
  "LemonStand": "LemonStand.png",
  "LessAccounting": "LessAccounting.png",
  "Lessonly": "Lessonly.jpg",
  "lexoffice": "lexoffice.png",
  "Lighthouse": "Lighthouse.png",
  "LIME Go": "LIMEGo.png",
  "Limo Anywhere": "LimoAnywhere.png",
  "LinkedIn": "LinkedIn.png",
  "LinkedIn Lead Gen Forms": "LinkedInLeadGenForms.png",
  "LinkedIn Matched Audiences": "LinkedInMatchedAudiences.png",
  "LionDesk": "LionDesk.png",
  "LiquidPlanner": "LiquidPlanner.png",
  "Listing Booster": "ListingBooster.png",
  "Listings To Leads": "ListingsToLeads.png",
  "LiveAgent": "LiveAgent.png",
  "LiveCall": "LiveCall.png",
  "LiveChat": "LiveChat.png",
  "Livestorm": "Livestorm.png",
  "Lob": "Lob.png",
  "Lockbin": "Lockbin.png",
  "Lono": "Lono.png",
  "Loopy Loyalty": "LoopyLoyalty.png",
  "Lucid Meetings": "LucidMeetings.png",
  "LumApps": "LumApps.png",
  "Lusha": "Lusha.png",
  "Lyft": "Lyft.png",
  "MadKudu": "MadKudu.png",
  "Mad Mimi": "MadMimi.png",
  "Magento": "Magento.png",
  "Magento 2.X": "Magento2X.png",
  "Magentrix": "Magentrix.png",
  "Magic Minutes": "MagicMinutes.png",
  "Magnetic": "Magnetic.png",
  "Magnetis": "Magnetis.png",
  "Magpi": "Magpi.png",
  "Dinamize": "Dinamize.png",
  "MailboxValidator": "MailboxValidator.png",
  "Mailchimp": "Mailchimp.png",
  "MailerLite": "MailerLite.png",
  "Mailgun": "Mailgun.png",
  "Mailigen": "Mailigen.png",
  "Mailjet": "Mailjet.png",
  "MailMojo": "MailMojo.png",
  "MailMunch": "MailMunch.png",
  "Mailparser": "Mailparser.png",
  "MailPlatform": "MailPlatform.png",
  "Mailshake": "Mailshake.png",
  "Manifestly": "Manifestly.png",
  "Maintenance Care": "MaintenanceCare.png",
  "Mandrill": "Mandrill.png",
  "MangoApps": "MangoApps.png",
  "ManyChat": "ManyChat.png",
  "MapMyFitness": "MapMyFitness.png",
  "Marketo": "Marketo.png",
  "MarketVolt": "MarketVolt.png",
  "MashApp": "MashApp.png",
  "MasterBase": "MasterBase.png",
  "Cypher Learning": "CypherLearning.png",
  "Mattermost": "Mattermost.png",
  "Mautic": "Mautic.png",
  "Mavenlink": "Mavenlink.png",
  "Maximizer": "Maximizer.png",
  "MeaningCloud": "MeaningCloud.png",
  "MediaSilo": "MediaSilo.png",
  "Mediatoolkit": "Mediatoolkit.png",
  "Meetingbird": "Meetingbird.png",
  "MeetingKing": "MeetingKing.png",
  "Meetup": "Meetup.png",
  "Megaventory": "Megaventory.png",
  "MeisterTask": "MeisterTask.png",
  "Meltwater": "Meltwater.png",
  "Memberful": "Memberful.png",
  "MemberSpace": "MemberSpace.png",
  "Mercury Connect": "MercuryConnect.png",
  "Mercury Web Parser": "MercuryWebParser.png",
  "Ytel": "Ytel.png",
  "MessageBird": "MessageBird.png",
  "MessageMedia": "MessageMedia.png",
  "Metatask": "Metatask.png",
  "Miestro": "Miestro.png",
  "Mighty Networks": "MightyNetworks.png",
  "MindManager": "MindManager.png",
  "Mingdao": "Mingdao.png",
  "Minute": "Minute.png",
  "Minute-It": "MinuteIt.png",
  "Mirabel's Marketing Manager": "MirabelsMarketingManager.png",
  "Mixpanel": "Mixpanel.png",
  "Mobiniti SMS": "MobinitiSMS.png",
  "MOBIT": "MOBIT.png",
  "MOCO": "MOCO.png",
  "Mojo": "Mojo.png",
  "Mojo Helpdesk": "MojoHelpdesk.png",
  "Moneybird": "Moneybird.png",
  "MongoDB": "MongoDB.png",
  "Monitis": "Monitis.png",
  "MonkeyLearn": "MonkeyLearn.png",
  "MoonClerk": "MoonClerk.png",
  "MoonMail": "MoonMail.png",
  "Moosend": "Moosend.png",
  "Moskit": "Moskit.png",
  "Moverbase": "Moverbase.png",
  "Moxtra": "Moxtra.png",
  "Microsoft Dynamics 365 CRM": "MicrosoftDynamics365CRM.png",
  "MSGHero": "MSGHero.png",
  "SQL Server": "SQLServer.png",
  "M-target": "Mtarget.png",
  "MyBizzMail": "MyBizzMail.png",
  "Myphoner": "Myphoner.png",
  "My Print Cloud": "MyPrintCloud.png",
  "MySQL": "MySQL.png",
  "MyWiFi Networks": "MyWiFiNetworks.png",
  "Nalpeiron": "Nalpeiron.png",
  "NationBuilder Nexus": "NationBuilderNexus.png",
  "naturalForms": "naturalForms.png",
  "Nearby Now": "NearbyNow.png",
  "NeonCRM": "NeonCRM.png",
  "Netex learningCloud": "NetexlearningCloud.png",
  "NetHunt CRM": "NetHuntCRM.png",
  "Netlify": "Netlify.png",
  "Neto": "Neto.png",
  "NeverBounce": "NeverBounce.png",
  "New Relic": "NewRelic.png",
  "New Relic Insights": "NewRelicInsights.png",
  "Newsman": "Newsman.png",
  "New York Times": "NewYorkTimes.png",
  "Next": "Next.png",
  "Nexticy": "Nexticy.png",
  "Nibo": "Nibo.png",
  "NiceJob": "NiceJob.png",
  "Nicereply": "Nicereply.png",
  "NiftyImages": "NiftyImages.png",
  "Nimble": "Nimble.png",
  "Ninja Forms": "NinjaForms.png",
  "Ninox": "Ninox.png",
  "Nintex": "Nintex.png",
  "noCRM.io": "noCRMio.png",
  "Noticeable": "Noticeable.png",
  "NUACOM": "NUACOM.png",
  "Nusii Proposals": "NusiiProposals.png",
  "Nutshell": "Nutshell.png",
  "Nuzzel News": "NuzzelNews.png",
  "Occasion": "Occasion.png",
  "Octopush SMS": "OctopushSMS.png",
  "OpenERP": "OpenERP.png",
  "Office 365": "Office365.png",
  "OfficeRnD": "OfficeRnD.png",
  "Olark": "Olark.png",
  "OMG Sales Assessments": "OMGSalesAssessments.png",
  "Omniconvert": "Omniconvert.png",
  "OmniFocus": "OmniFocus.png",
  "Omnify": "Omnify.png",
  "Omnisend": "Omnisend.png",
  "ON24": "ON24.png",
  "OneBill": "OneBill.png",
  "1CRM": "1CRM.png",
  "OneDesk": "OneDesk.png",
  "OneDrive": "OneDrive.png",
  "OneLocal ContactHub": "OneLocalContactHub.png",
  "OneLocal QuickConnect": "OneLocalQuickConnect.png",
  "OneLocal ReferralMagic": "OneLocalReferralMagic.png",
  "OneLocal ReviewEdge": "OneLocalReviewEdge.png",
  "OneNote": "OneNote.png",
  "OnePageCRM": "OnePageCRM.png",
  "OneScreen Interactive": "OneScreenInteractive.png",
  "OneSignal": "OneSignal.png",
  "Onfleet": "Onfleet.png",
  "OnStrategy": "OnStrategy.png",
  "Ontraport": "Ontraport.png",
  "OpenAsset": "OpenAsset.png",
  "Opesta": "Opesta.png",
  "OpsGenie": "OpsGenie.png",
  "Otixo": "Otixo.png",
  "Outgrow": "Outgrow.png",
  "Overpass": "Overpass.png",
  "PageProof": "PageProof.png",
  "PagerDuty": "PagerDuty.png",
  "Pagico": "Pagico.png",
  "PandaDoc": "PandaDoc.png",
  "Paperform": "Paperform.png",
  "Pardot": "Pardot.png",
  "Parolu": "Parolu.png",
  "Parserr": "Parserr.png",
  "Parseur": "Parseur.png",
  "PartnerStack": "PartnerStack.png",
  "Patreon": "Patreon.png",
  "Payment Rails": "PaymentRails.png",
  "Paymo": "Paymo.png",
  "PayPal": "PayPal.png",
  "PayPro": "PayPro.png",
  "PDFfiller": "PDFfiller.png",
  "People HR": "PeopleHR.png",
  "Pepipost": "Pepipost.jpg",
  "Perfect Tense": "PerfectTense.png",
  "PersistIQ": "PersistIQ.png",
  "Phaxio": "Phaxio.png",
  "Philips SpeechLive": "PhilipsSpeechLive.png",
  "PhoneTrack": "PhoneTrack.png",
  "PhoneWagon": "PhoneWagon.png",
  "Picatic": "Picatic.png",
  "Picreel": "Picreel.png",
  "Pinterest": "Pinterest.png",
  "Pipedrive": "Pipedrive.png",
  "Pipefy": "Pipefy.png",
  "PipelineDeals": "PipelineDeals.png",
  "Pipeliner": "Pipeliner.png",
  "Pivotal Tracker": "PivotalTracker.png",
  "Planbox Work": "PlanboxWork.png",
  "Planning Pod": "PlanningPod.png",
  "PlanSo Forms for WordPress": "PlanSoFormsforWordPress.png",
  "Planyo Online Booking": "PlanyoOnlineBooking.png",
  "PlatoForms": "PlatoForms.png",
  "PlayFilm": "PlayFilm.png",
  "Plecto": "Plecto.png",
  "Plivo": "Plivo.png",
  "Pobuca Connect": "PobucaConnect.png",
  "Pocket": "Pocket.png",
  "Podio": "Podio.png",
  "Pointagram": "Pointagram.png",
  "PomoDoneApp": "PomoDoneApp.png",
  "Poptin": "Poptin.png",
  "Happy Grasshopper": "HappyGrasshopper.png",
  "Postalytics": "Postalytics.png",
  "PostgreSQL": "PostgreSQL.png",
  "Postmark": "Postmark.png",
  "Powrbot": "Powrbot.png",
  "POWr Form Builder": "POWrFormBuilder.png",
  "Practice Ignition": "PracticeIgnition.png",
  "PracticePanther Legal Software": "PracticePantherLegalSoftware.png",
  "PractiTest": "PractiTest.png",
  "PreciseFP": "PreciseFP.png",
  "Prefinery": "Prefinery.png",
  "Printavo": "Printavo.png",
  "Printfection": "Printfection.png",
  "Privy": "Privy.png",
  "Pro Agent Solutions": "ProAgentSolutions.png",
  "ProAgentWebsites.com": "ProAgentWebsitescom.png",
  "ProcessPlan": "ProcessPlan.png",
  "Process Street": "ProcessStreet.png",
  "Procore": "Procore.png",
  "ProcurementExpress.com": "ProcurementExpresscom.png",
  "ProdPad": "ProdPad.png",
  "Productboard": "Productboard.png",
  "Project Bubble": "ProjectBubble.png",
  "Project Manager": "ProjectManager.png",
  "Projectplace": "Projectplace.png",
  "Promoter.io": "Promoterio.png",
  "Proof": "Proof.png",
  "Proposify": "Proposify.png",
  "Prospect.io": "Prospectio.png",
  "ProWorkflow": "ProWorkflow.png",
  "PulseM": "PulseM.png",
  "Pure360": "Pure360.png",
  "Pure Chat": "PureChat.png",
  "PushBIZ": "PushBIZ.png",
  "Pusher": "Pusher.png",
  "Pushover": "Pushover.png",
  "Qblinks": "Qblinks.png",
  "Qrvey": "Qrvey.png",
  "Quaderno": "Quaderno.png",
  "Qualaroo": "Qualaroo.png",
  "Quentn": "Quentn.png",
  "QuestionPro": "QuestionPro.png",
  "Quick Base": "QuickBase.png",
  "QuickBooks Online": "QuickBooksOnline.png",
  "QuickFile": "QuickFile.png",
  "QuickMail.io": "QuickMailio.png",
  "QuickTapSurvey": "QuickTapSurvey.png",
  "Quip": "Quip.png",
  "Quiz Maker": "QuizMaker.png",
  "Quotient": "Quotient.png",
  "Qwilr": "Qwilr.png",
  "awork": "awork.png",
  "Ragic": "Ragic.png",
  "Rare.io": "Rareio.png",
  "Ratecard": "Ratecard.png",
  "Mightycause": "Mightycause.png",
  "RD Station": "RDStation.png",
  "ReachMail": "ReachMail.png",
  "Real Estate Webmasters": "RealEstateWebmasters.png",
  "Real Geeks": "RealGeeks.png",
  "Really Simple Systems CRM": "ReallySimpleSystemsCRM.png",
  "Real Magnet": "RealMagnet.png",
  "RealScout": "RealScout.png",
  "Realvolve": "Realvolve.png",
  "Reamaze": "Reamaze.png",
  "Rebrandly": "Rebrandly.png",
  "Receptive": "Receptive.png",
  "ReCharge": "ReCharge.png",
  "Reckon One": "ReckonOne.png",
  "Recras": "Recras.png",
  "Recruitee": "Recruitee.png",
  "Recurly": "Recurly.png",
  "Redbooth": "Redbooth.png",
  "Reddit": "Reddit.png",
  "Redmine": "Redmine.png",
  "Redtail CRM": "RedtailCRM.png",
  "Referral Rock": "ReferralRock.png",
  "REIPro": "REIPro.png",
  "Remarkety": "Remarkety.png",
  "Remember The Milk": "RememberTheMilk.png",
  "RepairShopr": "RepairShopr.png",
  "Reply": "Reply.png",
  "ReportGarden": "ReportGarden.png",
  "Repsly": "Repsly.png",
  "RescueTime": "RescueTime.png",
  "Resource Guru": "ResourceGuru.png",
  "Restyaboard": "Restyaboard.png",
  "Retently": "Retently.png",
  "Revamp CRM": "RevampCRM.png",
  "RevBoss": "RevBoss.png",
  "Rev": "Rev.png",
  "Rev.io": "Revio.jpg",
  "Revolut for Business": "RevolutforBusiness.png",
  "Revue": "Revue.png",
  "Revv": "Revv.png",
  "Reward Sciences": "RewardSciences.png",
  "rezora": "rezora.png",
  "Riddle Quiz Maker": "RiddleQuizMaker.png",
  "Ridehire": "Ridehire.png",
  "RightSignature": "RightSignature.png",
  "RingByName": "RingByName.png",
  "RingCentral": "RingCentral.png",
  "Robly": "Robly.png",
  "Rocket.Chat": "RocketChat.png",
  "RocketReach": "RocketReach.png",
  "RocketResponder": "RocketResponder.png",
  "Rokt": "Rokt.png",
  "Roll": "Roll.png",
  "Ronin": "Ronin.png",
  "Roost": "Roost.png",
  "Route4Me": "Route4Me.png",
  "Route": "Route.png",
  "Routee": "Routee.png",
  "birdsnest": "birdsnest.png",
  "RowShare": "RowShare.png",
  "Ruler Analytics": "RulerAnalytics.png",
  "Runkeeper": "Runkeeper.png",
  "Run my Accounts": "RunmyAccounts.png",
  "Runrun.it": "Runrunit.png",
  "Runscope": "Runscope.png",
  "Ruum by SAP": "RuumbySAP.png",
  "Ryver": "Ryver.png",
  "Amazon S3": "AmazonS3.png",
  "Saasu": "Saasu.png",
  "iAuditor by SafetyCulture": "iAuditorbySafetyCulture.png",
  "Sakari SMS": "SakariSMS.png",
  "Salesflare": "Salesflare.png",
  "Salesforce": "Salesforce.png",
  "SalesforceIQ": "SalesforceIQ.png",
  "Salesmachine": "Salesmachine.png",
  "Salesmate": "Salesmate.png",
  "Salesmsg": "Salesmsg.png",
  "SalesRabbit": "SalesRabbit.png",
  "CallMonkey": "CallMonkey.png",
  "SalesUp!": "SalesUp.png",
  "Salpo CRM": "SalpoCRM.png",
  "SamCart": "SamCart.png",
  "Samepage": "Samepage.png",
  "Sandglaz": "Sandglaz.png",
  "Sansan": "Sansan.png",
  "SAP Jam Collaboration": "SAPJamCollaboration.png",
  "Sarbacane": "Sarbacane.png",
  "SatisMeter": "SatisMeter.png",
  "Scalr": "Scalr.png",
  "Schedule It": "ScheduleIt.png",
  "ScheduleOnce": "ScheduleOnce.png",
  "Scoop.it": "Scoopit.png",
  "Scoro": "Scoro.png",
  "Seg": "Seg.png",
  "Sellead": "Sellead.png",
  "Sellf": "Sellf.png",
  "Sellfy": "Sellfy.png",
  "Sellsy": "Sellsy.png",
  "Selz": "Selz.png",
  "SendGrid": "SendGrid.png",
  "SendinBlue": "SendinBlue.png",
  "Sendlane": "Sendlane.png",
  "Sendloop": "Sendloop.png",
  "SendOwl": "SendOwl.png",
  "SendPulse": "SendPulse.png",
  "SendSafely": "SendSafely.png",
  "SendX": "SendX.png",
  "Sendy": "Sendy.png",
  "SeoToaster": "SeoToaster.png",
  "SE Ranking": "SERanking.png",
  "ServeManager": "ServeManager.png",
  "Serviceaide": "Serviceaide.png",
  "ServiceM8": "ServiceM8.png",
  "ServiceTrade": "ServiceTrade.png",
  "SerwerSMS": "SerwerSMS.png",
  "Amazon SES": "AmazonSES.png",
  "Sezion": "Sezion.png",
  "Optix": "Optix.png",
  "Citrix ShareFile": "CitrixShareFile.png",
  "SharpCloud": "SharpCloud.png",
  "SharpSpring": "SharpSpring.png",
  "shipcloud": "shipcloud.png",
  "ShipStation": "ShipStation.png",
  "Shopify": "Shopify.png",
  "Short.cm": "Shortcm.png",
  "Showcase IDX": "ShowcaseIDX.png",
  "Sidekick": "Sidekick.png",
  "Sifter": "Sifter.png",
  "Signaturit": "Signaturit.png",
  "Signority": "Signority.png",
  "SignRequest": "SignRequest.png",
  "SignUpAnywhere": "SignUpAnywhere.png",
  "SignUpGenius": "SignUpGenius.png",
  "Sign-Up.to": "SignUpto.png",
  "Simplero": "Simplero.png",
  "Simplesat": "Simplesat.png",
  "SimpleTexting": "SimpleTexting.png",
  "SimplyBook": "SimplyBook.png",
  "Site24x7": "Site24x7.png",
  "Siteleaf": "Siteleaf.png",
  "Skedda": "Skedda.png",
  "SkedPal": "SkedPal.jpg",
  "Skilljar": "Skilljar.png",
  "Skubana": "Skubana.png",
  "Slack": "Slack.png",
  "Slenke": "Slenke.png",
  "SlickText": "SlickText.png",
  "Slybroadcast": "Slybroadcast.png",
  "Small Improvements": "SmallImprovements.png",
  "SmartEmailing": "SmartEmailing.png",
  "SmartReach": "SmartReach.png",
  "Smartsheet": "Smartsheet.png",
  "SmartSurvey": "SmartSurvey.png",
  "46elks": "46elks.png",
  "SMS Alert": "SMSAlert.png",
  "SMSAPI": "SMSAPI.png",
  "SMSFactor": "SMSFactor.png",
  "Smshosting": "Smshosting.png",
  "SMS Partner": "SMSPartner.png",
  "Snappy": "Snappy.png",
  "Sniply": "Sniply.png",
  "Snippet": "Snippet.png",
  "Amazon SNS": "AmazonSNS.png",
  "Social Intents": "SocialIntents.png",
  "SocialPilot": "SocialPilot.png",
  "SoGoSurvey": "SoGoSurvey.png",
  "Kaleyra": "Kaleyra.png",
  "Solve CRM": "SolveCRM.png",
  "Songkick": "Songkick.png",
  "Sonix": "Sonix.png",
  "Spacio": "Spacio.png",
  "Spark Chart": "SparkChart.png",
  "Spark Hire": "SparkHire.png",
  "SparkPost": "SparkPost.png",
  "Speak2Leads": "Speak2Leads.png",
  "SpeechTrans": "SpeechTrans.png",
  "Spiro": "Spiro.png",
  "Splash": "Splash.png",
  "Splitwise": "Splitwise.png",
  "Spoke": "Spoke.png",
  "Spondyr": "Spondyr.png",
  "Spotify": "Spotify.png",
  "Spotio": "Spotio.png",
  "Sprintly": "Sprintly.png",
  "Amazon SQS": "AmazonSQS.png",
  "Square": "Square.png",
  "Squarespace": "Squarespace.png",
  "Stackla": "Stackla.png",
  "Stannp": "Stannp.png",
  "StartupThreads": "StartupThreads.png",
  "StatusCake": "StatusCake.png",
  "Status Hero": "StatusHero.png",
  "Statusy": "Statusy.png",
  "Steady": "Steady.png",
  "Storenvy": "Storenvy.png",
  "Stormboard": "Stormboard.png",
  "StoryChief": "StoryChief.png",
  "Strava": "Strava.png",
  "Streak": "Streak.png",
  "StreamSend": "StreamSend.png",
  "Streamtime": "Streamtime.png",
  "StreetText": "StreetText.png",
  "Stripe": "Stripe.png",
  "Submittable": "Submittable.png",
  "SugarCRM 6.2-5": "SugarCRM625.png",
  "SugarCRM 7+": "SugarCRM7.png",
  "SugarSync": "SugarSync.png",
  "Sumo": "Sumo.png",
  "SuperOffice CRM": "SuperOfficeCRM.jpg",
  "Super Receptionist": "SuperReceptionist.png",
  "SuperSaaS": "SuperSaaS.png",
  "SupportBee": "SupportBee.png",
  "Surefire CRM": "SurefireCRM.png",
  "Survey Anyplace": "SurveyAnyplace.png",
  "Surveybot": "Surveybot.png",
  "Survey Funnel": "SurveyFunnel.png",
  "SurveyGizmo": "SurveyGizmo.png",
  "SurveyMethods": "SurveyMethods.png",
  "SurveyMonkey": "SurveyMonkey.png",
  "SurveyNuts": "SurveyNuts.png",
  "Surveypal": "Surveypal.png",
  "SurveySparrow": "SurveySparrow.png",
  "SweepBright": "SweepBright.png",
  "Swiftype": "Swiftype.png",
  "Swisscom iO": "SwisscomiO.png",
  "Symphony": "Symphony.png",
  "TailoredMail": "TailoredMail.png",
  "TalentLMS": "TalentLMS.png",
  "talkSpirit": "talkSpirit.png",
  "Tallyfy": "Tallyfy.png",
  "Tango Card": "TangoCard.png",
  "Tapfiliate": "Tapfiliate.png",
  "Targeto": "Targeto.png",
  "Targetprocess": "Targetprocess.png",
  "Task Pigeon": "TaskPigeon.png",
  "Teachable": "Teachable.png",
  "Teachery": "Teachery.png",
  "Teamchat": "Teamchat.png",
  "Teamgate": "Teamgate.png",
  "TeamGram": "TeamGram.png",
  "Teamie": "Teamie.png",
  "TeamWave": "TeamWave.png",
  "Teamwork Desk": "TeamworkDesk.png",
  "Teamwork Projects": "TeamworkProjects.png",
  "TeleSign": "TeleSign.png",
  "Telzio": "Telzio.png",
  "Temi": "Temi.png",
  "Tend": "Tend.png",
  "10,000ft": "10000ft.png",
  "TestMonitor": "TestMonitor.png",
  "Tettra": "Tettra.png",
  "TextIt": "TextIt.png",
  "Textline": "Textline.png",
  "Textlocal": "Textlocal.png",
  "TextMagic": "TextMagic.png",
  "Text Request": "TextRequest.png",
  "Thankster": "Thankster.png",
  "The 90 Day Year": "The90DayYear.png",
  "Things": "Things.png",
  "Thinkific": "Thinkific.png",
  "3dcart": "3dcart.png",
  "Thryv": "Thryv.png",
  "ThunderMaps": "ThunderMaps.png",
  "Tick": "Tick.png",
  "Ticketbud": "Ticketbud.png",
  "TicketCo": "TicketCo.png",
  "Ticket Tailor": "TicketTailor.png",
  "Tilkee": "Tilkee.png",
  "TimeCamp": "TimeCamp.png",
  "Time Doctor": "TimeDoctor.png",
  "TimeHero": "TimeHero.png",
  "Timekit": "Timekit.png",
  "TimeLive": "TimeLive.png",
  "Time Tracker": "TimeTracker.png",
  "TMetric": "TMetric.png",
  "Todoist": "Todoist.png",
  "Toggl": "Toggl.png",
  "Toky": "Toky.png",
  "Tookan": "Tookan.png",
  "Tortii": "Tortii.png",
  "Totango": "Totango.png",
  "TPNI Engage": "TPNIEngage.png",
  "TrackVia": "TrackVia.png",
  "TractionNext": "TractionNext.png",
  "TradeGecko": "TradeGecko.png",
  "Trainerize": "Trainerize.png",
  "Trainual": "Trainual.png",
  "TransForm": "TransForm.png",
  "Transloadit": "Transloadit.png",
  "Transporters.io": "Transportersio.png",
  "TrekkSoft": "TrekkSoft.png",
  "Trello": "Trello.png",
  "Tribecube": "Tribecube.png",
  "TRIBUS CRM": "TRIBUSCRM.png",
  "TRIGGERcmd": "TRIGGERcmd.png",
  "Trint": "Trint.png",
  "Trustpilot": "Trustpilot.png",
  "Tubular": "Tubular.png",
  "Tumblr": "Tumblr.png",
  "Turbine": "Turbine.png",
  "24sessions": "24sessions.png",
  "Twilio": "Twilio.png",
  "Twist": "Twist.png",
  "Twitter": "Twitter.png",
  "Twizo": "Twizo.png",
  "txtNation": "txtNation.png",
  "Typeform": "Typeform.png",
  "Unbounce": "Unbounce.png",
  "UnifiedFactory Easy": "UnifiedFactoryEasy.png",
  "Unisender": "Unisender.png",
  "Universe": "Universe.png",
  "Untappd": "Untappd.png",
  "Upcall": "Upcall.png",
  "UpCity": "UpCity.png",
  "UPilot": "UPilot.png",
  "UpKeep": "UpKeep.png",
  "Uploadcare": "Uploadcare.png",
  "UpViral": "UpViral.png",
  "Upwave": "Upwave.png",
  "Urlooker": "Urlooker.png",
  "Uscreen": "Uscreen.png",
  "UserEngage": "UserEngage.png",
  "UserVoice": "UserVoice.png",
  "Vainu.io": "Vainuio.png",
  "VBOUT": "VBOUT.png",
  "vCita": "vCita.jpg",
  "Veeqo": "Veeqo.png",
  "Verified Reviews": "VerifiedReviews.png",
  "Verloop": "Verloop.png",
  "VerticalResponse": "VerticalResponse.png",
  "Vervoe": "Vervoe.png",
  "Vextras": "Vextras.jpg",
  "viewneo": "viewneo.png",
  "ViewPoint VISUM": "ViewPointVISUM.png",
  "Vimeo": "Vimeo.png",
  "Vinli": "Vinli.png",
  "Smoove": "Smoove.png",
  "ViralSweep": "ViralSweep.png",
  "Visage": "Visage.png",
  "Visible": "Visible.png",
  "Vision6": "Vision6.png",
  "Visitor Queue": "VisitorQueue.png",
  "VisitorTrack": "VisitorTrack.png",
  "Visual Lease": "VisualLease.png",
  "Azure DevOps": "AzureDevOps.png",
  "Visual Visitor": "VisualVisitor.png",
  "VIVAHR": "VIVAHR.png",
  "VoilaNorbert": "VoilaNorbert.png",
  "Volusion": "Volusion.png",
  "Voodoo SMS": "VoodooSMS.png",
  "Vookmark": "Vookmark.png",
  "Voxer": "Voxer.png",
  "Vtiger CRM": "VtigerCRM.png",
  "vzaar": "vzaar.png",
  "Wachete": "Wachete.png",
  "WaiverForever": "WaiverForever.png",
  "Watershed LRS": "WatershedLRS.png",
  "Wave": "Wave.png",
  "Wealthbox CRM": "WealthboxCRM.png",
  "Web CEO": "WebCEO.png",
  "Webflow": "Webflow.png",
  "WebinarGeek": "WebinarGeek.png",
  "WebinarJam": "WebinarJam.png",
  "WebinarNinja": "WebinarNinja.png",
  "Webinato": "Webinato.png",
  "WebMerge": "WebMerge.png",
  "Websand": "Websand.png",
  "Weekdone": "Weekdone.png",
  "Week Plan": "WeekPlan.png",
  "Weemss": "Weemss.png",
  "Whaller": "Whaller.png",
  "WhatConverts": "WhatConverts.png",
  "WHMCS": "WHMCS.gif",
  "Widen Collective": "WidenCollective.png",
  "Wimi": "Wimi.png",
  "WinSMS": "WinSMS.png",
  "Wintouch 7": "Wintouch7.png",
  "Wire2Air": "Wire2Air.png",
  "Wise Agent CRM": "WiseAgentCRM.png",
  "WisePops": "WisePops.png",
  "Wishpond": "Wishpond.png",
  "Wistia": "Wistia.png",
  "Wix Answers": "WixAnswers.png",
  "Wodify Core": "WodifyCore.jpg",
  "Woobox": "Woobox.png",
  "WooCommerce": "WooCommerce.png",
  "Woodpecker.co": "Woodpeckerco.png",
  "Wootric": "Wootric.png",
  "Wordapp": "Wordapp.png",
  "WordPress": "WordPress.png",
  "Wordsmith": "Wordsmith.png",
  "Workable": "Workable.png",
  "Workast": "Workast.png",
  "Workboard": "Workboard.png",
  "Workbooks CRM": "WorkbooksCRM.png",
  "WorkingOn": "WorkingOn.png",
  "Workstack": "Workstack.png",
  "Workzone": "Workzone.png",
  "WP All Export Pro": "WPAllExportPro.png",
  "WPForms": "WPForms.png",
  "Wrike": "Wrike.png",
  "Wufoo": "Wufoo.png",
  "Wunderlist": "Wunderlist.png",
  "x.ai": "xai.png",
  "Xero": "Xero.png",
  "XING Events": "XINGEvents.png",
  "xMatters": "xMatters.png",
  "Xola": "Xola.png",
  "Xooa": "Xooa.png",
  "XY Find It": "XYFindIt.png",
  "Yalla": "Yalla.png",
  "Yammer": "Yammer.png",
  "Yanado": "Yanado.png",
  "YesInsights": "YesInsights.png",
  "Yocale": "Yocale.png",
  "YoCo Board": "YoCoBoard.png",
  "Yodel.io Phone System": "YodelioPhoneSystem.png",
  "Yodiz": "Yodiz.png",
  "YouCanBook.Me": "YouCanBookMe.png",
  "YouTube": "YouTube.png",
  "Yumpu": "Yumpu.png",
  "Zapty": "Zapty.png",
  "Zaxaa": "Zaxaa.png",
  "Zendesk Sell": "ZendeskSell.png",
  "Zendesk": "Zendesk.png",
  "ZenDirect": "ZenDirect.png",
  "Zenegy": "Zenegy.png",
  "Zengine": "Zengine.png",
  "Zenkit": "Zenkit.png",
  "zenloop": "zenloop.png",
  "Ziggeo": "Ziggeo.png",
  "Zillow Tech Connect": "ZillowTechConnect.png",
  "zipForm Plus": "zipFormPlus.png",
  "Zipwhip": "Zipwhip.png",
  "Zipzappo": "Zipzappo.png",
  "Zoho Books": "ZohoBooks.png",
  "Zoho Cliq": "ZohoCliq.png",
  "Zoho Connect": "ZohoConnect.png",
  "Zoho Creator": "ZohoCreator.png",
  "Zoho CRM": "ZohoCRM.png",
  "Zoho Desk": "ZohoDesk.png",
  "Zoho Forms": "ZohoForms.png",
  "Zoho Invoice": "ZohoInvoice.png",
  "Zoho Mail": "ZohoMail.png",
  "Zoho Notebook": "ZohoNotebook.png",
  "Zoho People": "ZohoPeople.png",
  "Zoho Projects": "ZohoProjects.png",
  "Zoho Recruit": "ZohoRecruit.png",
  "Zoho Reports": "ZohoReports.png",
  "Zoho Sheet": "ZohoSheet.png",
  "Zoho Sprints": "ZohoSprints.png",
  "Zoho Subscriptions": "ZohoSubscriptions.png",
  "Zoho WorkDrive": "ZohoWorkDrive.png",
  "Zoho Writer": "ZohoWriter.png",
  "Zonka Feedback": "ZonkaFeedback.png",
  "Zoom": "Zoom.png",
};

class IntegrationTable extends Component {
  click = i => {
    this._link.click();
  }

  render() {
    var p = this.props;

    return (
      <table className="table int-table">
        <thead>
          <tr>
            <th colSpan={2}>
              <a ref={r => this._link = r} style={{display:'none'}} target="_blank" rel="noopener noreferrer" href="https://zapier.com/developer/invite/102696/fcba22b133081f3d062ce60d74873844/">invisible link</a>
              {p.name}
            </th>
          </tr>
        </thead>
        <tbody>
          {
            _.map(p.rows, r =>
              <tr key={r} onClick={this.click.bind(null, r)}>
                <td>
                  <img src={'/img/integrations/' + images[r]} alt={r} /> 
                </td>
                <td>
                  {r}
                </td>
              </tr>
            )
          }
        </tbody>
      </table>
    );
  }
}

export default class Integrations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      results: null,
    };

    this._genResults = _.debounce(this.genResults, 300);
  }

  onChange = e => {
    this.setState({search: e.target.value}, this._genResults);
  }

  genResults = () => {
    if (this.state.search === '') {
      this.setState({results: null});
    } else {
      this.setState({results: _.sortBy(_.filter(_.keys(images), f => f.toLowerCase().includes(this.state.search.toLowerCase())), k => k.toLowerCase())});
    }
  }

  render() {
    return (
      <MenuNavbar {...this.props}>
        <TitlePage title="Zapier Integrations" />
        <div id="int">
          <div style={{ margin: "20px 0", textAlign: "center" }}>
            <div>
              We'll walk you through the process of connecting Zapier, just open a support request.
            </div>
          </div>
          <input onChange={this.onChange} value={this.state.search} id="int-search" className="form-control" placeholder="Search..." />
          {
          this.state.results === null ?
          <div>
            <IntegrationTable name="Popular" rows={[
              'Google Sheets', 'Facebook Lead Ads', 'ClickFunnels', 'Mailchimp', 'ActiveCampaign', 'Shopify'
            ]} />
            <IntegrationTable name="CRM" rows={[
              'HubSpot CRM', 'Salesforce', 'Infusionsoft'
            ]} />
            <IntegrationTable name="Forms" rows={[
              'Typeform', 'Google Forms', 'Gravity Forms'
            ]} />
            <IntegrationTable name="Contacts" rows={[
              'Google Contacts', 'FullContact', 'Clearbit'
            ]} />
          </div>
          :
            <IntegrationTable name="Search Results" rows={this.state.results} />
          }
        </div>
      </MenuNavbar>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Integrations.js